/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findOneFormProfileSnapshot } from '../fn/form-profile-snapshot/find-one-form-profile-snapshot';
import { FindOneFormProfileSnapshot$Params } from '../fn/form-profile-snapshot/find-one-form-profile-snapshot';
import { FormProfileSnapshot } from '../models/form-profile-snapshot';
import { FormProfileSnapshotRefreshDto } from '../models/form-profile-snapshot-refresh-dto';
import { refreshFormProfileSnapshot } from '../fn/form-profile-snapshot/refresh-form-profile-snapshot';
import { RefreshFormProfileSnapshot$Params } from '../fn/form-profile-snapshot/refresh-form-profile-snapshot';

@Injectable({ providedIn: 'root' })
export class FormProfileSnapshotService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formProfileSnapshotControllerFindOneFormProfileSnapshot()` */
  static readonly FormProfileSnapshotControllerFindOneFormProfileSnapshotPath = '/forms/{formId}/profile-snapshot';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOneFormProfileSnapshot()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneFormProfileSnapshot$Response(
    params: FindOneFormProfileSnapshot$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormProfileSnapshot>> {
    return findOneFormProfileSnapshot(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOneFormProfileSnapshot$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneFormProfileSnapshot(
    params: FindOneFormProfileSnapshot$Params,
    context?: HttpContext
  ): Observable<FormProfileSnapshot> {
    return this.findOneFormProfileSnapshot$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormProfileSnapshot>): FormProfileSnapshot => r.body)
    );
  }

  /** Path part for operation `formProfileSnapshotControllerRefreshFormProfileSnapshot()` */
  static readonly FormProfileSnapshotControllerRefreshFormProfileSnapshotPath =
    '/forms/{formId}/profile-snapshot/refresh';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refreshFormProfileSnapshot()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshFormProfileSnapshot$Response(
    params: RefreshFormProfileSnapshot$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormProfileSnapshotRefreshDto>> {
    return refreshFormProfileSnapshot(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `refreshFormProfileSnapshot$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshFormProfileSnapshot(
    params: RefreshFormProfileSnapshot$Params,
    context?: HttpContext
  ): Observable<FormProfileSnapshotRefreshDto> {
    return this.refreshFormProfileSnapshot$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormProfileSnapshotRefreshDto>): FormProfileSnapshotRefreshDto => r.body)
    );
  }
}
